import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { Dialog, DialogHeader, DialogTitle, DialogBody, DialogFooter } from "../Dialog";
import Button from "../Buttons/Button";
import { color, fontFamily } from "../tokens";

/**
 * Small confirmation dialog that opens on top of the current page or dialog.
 *
 * @param {boolean}         open
 * @param {string}          title
 * @param {React.ReactNode} message
 * @param {string}          [confirmLabel] - defaults to common.confirm
 * @param {Function}        onConfirm
 * @param {Function}        onCancel       - also called on backdrop click / escape
 * @param {boolean}         [destructive]  - red confirm button
 * @param {boolean}         [loading]      - shows a spinner on the confirm button and blocks cancelling
 */
export default function ConfirmDialog({ open, title, message, confirmLabel, onConfirm, onCancel, destructive = false, loading = false }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleCancel = () => {
    if (!loading) onCancel();
  };

  return (
    <Dialog open={!!open} onClose={handleCancel} maxWidth="xs">
      <DialogHeader closeable={false}>
        <DialogTitle>{title}</DialogTitle>
      </DialogHeader>
      <DialogBody>
        <p className={classes.message}>{message}</p>
      </DialogBody>
      <DialogFooter>
        <Button variant="light" size="small" onClick={handleCancel} disabled={loading}>
          {t("common.cancel")}
        </Button>
        <Button variant={destructive ? "destructive" : "primary"} size="small" onClick={onConfirm} loading={loading}>
          {confirmLabel || t("common.confirm")}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}

const useStyles = makeStyles(() => ({
  message: {
    margin: 0,
    fontSize: 14,
    fontFamily: fontFamily.base,
    color: color.text.secondary,
  },
}));
